import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimezoneUtilsService {

  constructor() { }

  /**
   * Converts @param date to an ISOString based on @param timezone.
   */
  public getISOStringTimezone(date: Date | moment.Moment, timezone: string): string {

    if (date instanceof Date) {
      date = moment(date);
    }

    const selectedDate = new Date(date.toString());
    const selectedHours =  selectedDate.getHours();
    const dstExtraHrtoUtc = moment.tz(date.format('YYYY-MM-DDTHH:mm:ss'),timezone).add(1,'hours').toISOString()
    const selectedUtcHr = moment.tz(date.format('YYYY-MM-DDTHH:mm:ss'),timezone).toISOString();
    return (this.isDSTEndDate(selectedDate) && !date.isDST() && selectedHours == 1) ? dstExtraHrtoUtc : selectedUtcHr ; 
   
  }

  public getUserTimeZone(previousDate: string): string {
    const date = previousDate.indexOf('Z') > -1 ? previousDate : previousDate + 'Z';
    return moment(new Date(date)).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
  }

  public addSecondsToDate(date: string, seconds: number): string {
    return moment(date).add(seconds, 's').toDate().toISOString();
  }

  public subtractSecondsToDate(date: string, seconds: number): string {
    return moment(date).subtract(seconds, 's').toDate().toISOString();
  }

  public isDSTEndDate(selectedDate: Date): boolean{
    const dateOfWeek = selectedDate.getDate()
    const dayOfWeek = selectedDate.getDay()
    const monthOfDate = selectedDate.getMonth()+1
    return (monthOfDate == 11 && dateOfWeek <= 7 && dayOfWeek == 0) ? true : false
  }

}
